import { combineReducers } from "redux";
import schemesDetails from "./Reducers/schemesReducers";
import mobileNumberState from "./Reducers/mobileNumberState";
import notificationAlert from "./Reducers/notificationState";
import seedScheme from "./Reducers/seedSchemeReducers";
import agentGrmDetails from "./Reducers/agentGrmReducers";
import profileData from "./Reducers/userProfileReducers";

export default combineReducers({
  schemesDetails,
  mobileNumberState,
  notificationAlert,
  seedScheme,
  agentGrmDetails,
  profileData,
});
